const caseStudies = [
    {
        title: "CONFIGURATION PATTERNS",
        description: "MONGODB (2026) - DESIGN PATTERN + ANIMATION [SLIDE DECK]",
        url: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-SN-Portfolio?node-id=1401-7146&t=YbTQ9twuTqCsr0ZO-8&scaling=scale-down&content-scaling=fixed&page-id=719%3A1896&starting-point-node-id=1401%3A7146&hide-ui=1",
        icon: "/images/book.svg"    
    },
    {
        title: "COLLECTION TOOLBAR",
        description: "MONGODB (2025) - DESIGN PATTERN + ANIMATION [SLIDE DECK]",
        url: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-SN-Portfolio?node-id=1401-33002&t=YbTQ9twuTqCsr0ZO-8&scaling=scale-down&content-scaling=fixed&page-id=719%3A1896&starting-point-node-id=1401%3A33002&hide-ui=1",
        icon: "/images/book.svg",
    },
    {
        title: "CODE EDITOR",
        description: "MONGODB (2025) - COMPONENT DESIGN [SLIDE DECK]",
        url: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-SN-Portfolio?node-id=1401-40625&t=YbTQ9twuTqCsr0ZO-8&scaling=scale-down&content-scaling=fixed&page-id=719%3A1896&starting-point-node-id=1401%3A40625&hide-ui=1",
        icon: "/images/book.svg",
    },
    {
        title: "PROGRESS BAR",
        description: "MONGODB (2025) - COMPONENT DESIGN + ANIMATION [SLIDE DECK]",
        url: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-SN-Portfolio?node-id=732-2314&t=i0axtqcTu0hWnxi4-8&scaling=scale-down&content-scaling=fixed&page-id=719%3A1896&starting-point-node-id=732%3A2314&hide-ui=1",
        icon: "/images/book.svg",
    },
    {
        title: "EXPOSING PROGRAMMATIC INTERFACES",
        description: "MONGODB (2025) - DESIGN PATTERN + ANIMATION [SLIDE DECK]",
        url: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-SN-Portfolio?node-id=731-20810&t=OS2JDpiGramNXsYZ-8&scaling=scale-down&content-scaling=fixed&page-id=719%3A1896&starting-point-node-id=731%3A20810&hide-ui=1",
        icon: "/images/book.svg"
    },
    {
        title: "NAVIGATING DESIGN SUCCESS",
        description: "MONGODB (2024) - LAYOUT ARCHITECTURE DESIGN [VIDEO]",
        url: "https://vimeo.com/954166531?share=copy",
        icon: "/images/video.svg"
    },
    {
        title: "MULTI-TOAST BEHAVIOR",
        description: "MONGODB (2022) - COMPONENT DESIGN + ANIMATION [SLIDE DECK]",
        url: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-SN-Portfolio?node-id=744-10361&t=jbnsuBNYY3pK86pu-8&scaling=scale-down&content-scaling=fixed&page-id=701%3A17&starting-point-node-id=744%3A10361&hide-ui=1",
        icon: "/images/book.svg"
    }

]

export default caseStudies;